<template>
    <b-card title="Option Warranty">
        <b-col cols="12">
            <b-table
                :fields="fields"
                :items="optionWarranty"
                show-empty
            >
                <template #cell(actions)="row">
                    <b-dropdown  id="dropdown-dropleft" variant="primary" size="sm" text="Menu" no-caret>
                        <template #button-content>
                            <feather-icon size="1x" icon="MenuIcon" />
                        </template>
                        <b-dropdown-item style="text-align:center" v-if="permission.edit">
                            <b-button variant="outline-primary" @click="toEditOption(row.item._id)">
                                <feather-icon icon="EditIcon"/>
                            </b-button>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
        </b-col>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import {userAccess} from '@/utils/utils'

export default {
    data() {
        return {
            fields: [
                { key: 'name', text: 'Name' },
                { key: 'month', text: 'Month' },
                { key: 'actions', text: 'Action' }
            ],
            optionWarranty: [],
            editPrompt: false,
        }
    },
    mounted() {
        this.getOptionWarranty().then((data) => {
            console.log(data)
            this.optionWarranty = data;
        })
    },
    methods: {
        ...mapActions({
            getOptionWarranty: 'warranty/getOptionWarranty'
        }),
        toEditOption(id) {
            this.$router.push(`/warranty/option-warranty/edit/${id}`)
        },
    },
    computed: {
        permission() {
      return userAccess("Option Warranty", "warranty_master_menu");
    },
    },
    created() {
    document.title = 'Option Warranty | RSP'
  },
}
</script>